import EventEmitter from 'eventemitter3';

export default class Overlay extends EventEmitter {
    expanded = false;

    setup() {
        this.overlay = document.querySelector('[data-overlay]');
        const buttonopen = document.querySelector('[data-overlay-open-button]');
        const buttonopenmobile = document.querySelector('[data-overlay-open-button-mobile]');
        const buttonclose = document.querySelector('[data-overlay-close-button]');

        if (buttonopen) {
            buttonopen.addEventListener('click', () => {
                this.open();
            });
        }

        if (buttonopenmobile) {
            buttonopenmobile.addEventListener('click', () => {
                this.open();
            });
        }

        if (buttonclose) {
            buttonclose.addEventListener('click', () => {
                this.close();
            });
        }
    }

    close() {
        this.expanded = false;
        this.overlay.classList.remove('overlay--expanded');
        document.body.classList.remove('overlay--expanded');
    }

    open() {
        this.expanded = true;
        this.overlay.classList.add('overlay--expanded');
        document.body.classList.add('overlay--expanded');
    }
}